import { AppUserModel } from "../../../infrastructure/model/AppUserModel";
import { AuthService } from "../../../infrastructure/services/AuthService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const loginUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    userName: string;
    password: string;
  }
): Promise<AppUserModel | undefined> => {
  const { password, userName, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: AppUserModel | undefined = undefined;
    const res = await AuthService.login(userName, password);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message || "Đăng nhập thất bại");
      },
      onSuccessWithData(res) {
        showSuccess?.("Chào mừng bạn đến với Toputii");
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const adminRegisterUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    isAdministrator: boolean;
    userName: string;
    password: string;
    fullName: string;
  }
): Promise<boolean> => {
  const { isAdministrator, password, userName, fullName, setLoading, showError, showSuccess } =
    deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    let res: any;
    if (isAdministrator) {
      res = await AuthService.administratorRegister(userName, password, fullName);
    } else {
      res = await AuthService.register(userName, password, fullName);
    }

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message || "Đăng kí thất bại");
      },
      onSuccess() {
        showSuccess?.("Đăng kí tài khoản thành công, đăng nhập để tiếp tục");
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
